export const driedConstants = {
  LIST_DRIED_REQUEST: 'LIST_DRIED_REQUEST',
  LIST_DRIED_SUCCESS: 'LIST_DRIED_SUCCESS',
  LIST_DRIED_FAILURE: 'LIST_DRIED_FAILURE'
};
